import { KBButton, KBFlex, KBTypography } from '@/components/atoms'
import { KBAlert } from '@/components/atoms/KBAlert'
import { useTranslation } from 'react-i18next'
import { useSearchParams } from 'react-router-dom'

const { Title } = KBTypography

const KNOWN_ERRORS: Record<string, string> = {
  not_company_email: 'auth.failure.personalEmailNotAllowed',
  email_already_exists: 'auth.failure.emailAlreadyRegistered',
  domain_already_exists: 'auth.failure.domainAlreadyRegistered',
}

const AuthFailure = () => {
  const { t } = useTranslation()
  const [searchParams] = useSearchParams()
  const error = searchParams.get('error') || 'unknown'
  const description = searchParams.get('description') || ''

  // Match known error patterns from the description text
  const getErrorMessage = (): string => {
    const desc = description.toLowerCase()
    if (
      desc.includes('company email') ||
      desc.includes('not_valid_company_email')
    ) {
      return t('auth.failure.personalEmailNotAllowed')
    }
    if (desc.includes('email') && desc.includes('exist')) {
      return t('auth.failure.emailAlreadyRegistered')
    }
    if (desc.includes('domain') && desc.includes('exist')) {
      return t('auth.failure.domainAlreadyRegistered')
    }
    // Check direct error code mapping
    if (KNOWN_ERRORS[error]) {
      return t(KNOWN_ERRORS[error])
    }
    return description || t('auth.failure.description')
  }

  return (
    <KBFlex
      vertical
      align="center"
      justify="center"
      className="tw-h-full tw-w-full tw-p-8"
      gap={24}
    >
      <Title level={3}>{t('auth.failure.title')}</Title>
      <KBAlert
        type="warning"
        showIcon
        className="tw-max-w-[480px]"
        message={getErrorMessage()}
      />
      <KBFlex gap={12}>
        <KBButton href="/register/form">{t('auth.failure.tryAgain')}</KBButton>
        <KBButton type="primary" href="/login">
          {t('auth.failure.backToLogin')}
        </KBButton>
      </KBFlex>
    </KBFlex>
  )
}

export default AuthFailure
